import React from 'react'
import IconButton from '@mui/material/IconButton'
import SvgIcon from '@mui/material/SvgIcon'
import HeartIcon from '../../../../icons/HeartIcon'
import HeartIconFilled from '../../../../icons/HeartIconFilled'

interface IProps {
  isAuthenticated?: boolean
  isInFavorites?: boolean

  onAddToFavorites(): Promise<void>
  onDeleteFromFavorites(): Promise<void>
}

const FavoritesBtn: React.FC<IProps> = ({
  onAddToFavorites,
  isAuthenticated,
  onDeleteFromFavorites,
  isInFavorites,
}) => {
  return (
    <div className={`favorites__btn ${isInFavorites ? 'added' : ''}`}>
      {isAuthenticated && (
        <IconButton onClick={isInFavorites ? onDeleteFromFavorites : onAddToFavorites}>
          <SvgIcon fontSize='large'>
            {isInFavorites ? (
              <HeartIconFilled viewBox='0 0 51.997 51.997' />
            ) : (
              <HeartIcon viewBox='0 0 51.997 51.997' />
            )}
          </SvgIcon>
        </IconButton>
      )}
    </div>
  )
}

export default FavoritesBtn
